import { useSelector } from "react-redux";
import makeStyles from "@mui/styles/makeStyles";

import { ROBOT_DRIVER_TYPE } from "../../../consts/driverTypes";

import {
  vehiclesSelector,
  sectionsSelector,
  driverInEditSelector,
  driversSelector,
  routesSelector,
} from "../../../reducers/matrixProfile/selectors";
import { WorkScheduleDayForm } from "../../WorkScheduleDayForm";

const useFormStyles = makeStyles({
  formContainer: {
    width: "500px",
    display: "grid",
    marginTop: "20px",
    gap: "20px",
  },

  // 1st Row
  odfDropDownContainer: {
    gridColumnStart: 1,
    gridColumnEnd: 5,
    gridRowStart: 1,
  },
  odfDropDown: {
    width: "70%",
  },
  // 2nd Row
  driverDropDownContainer: {
    gridColumnStart: 1,
    gridColumnEnd: 5,
    gridRowStart: 2,
  },
  driverDropDown: {
    width: "100%",
  },

  // 3rd Row
  dutyStartTimeContainer: {
    gridColumnStart: 1,
    gridRowStart: 3,
  },
  dutyEndTimeContainer: {
    gridColumnStart: 2,
    gridRowStart: 3,
  },
  totalDutyTimeContainer: {
    gridColumnStart: 3,
    gridRowStart: 3,
  },

  // 4th Row
  plannedDepartTimeContainer: {
    gridColumnStart: 1,
    gridRowStart: 4,
  },
  plannedReturnTimeContainer: {
    gridColumnStart: 2,
    gridRowStart: 4,
  },
  amTimeInDepotContainer: {
    gridColumnStart: 3,
    gridRowStart: 4,
  },
  pmTimeInDepotContainer: {
    gridColumnStart: 4,
    gridRowStart: 4,
  },

  // 5th Row
  deliveryStopTimeContainer: {
    gridColumnStart: 1,
    gridRowStart: 5,
  },
  collectionStopTimeContainer: {
    gridColumnStart: 2,
    gridRowStart: 5,
  },
  vehicleDropDownContainer: {
    gridColumnStart: 3,
    gridColumnEnd: 5,
    gridRowStart: 5,
  },
  vehicleDropDown: {
    width: "100%",
  },

  // 6th Row
  robotTypeCodeDropDownContainer: {
    gridColumnStart: 1,
    gridColumnEnd: 4,
    gridRowStart: 6,
    width: "80%",
  },
  robotTypeCodeDropDown: {
    width: "100%",
  },

  // 6/7th Row
  sectionDropDownContainer: ({ isRobot }) => ({
    gridColumnStart: 1,
    gridColumnEnd: 4,
    gridRowStart: isRobot ? 7 : 6,
    width: "80%",
  }),
  sectionDropDown: {
    width: "100%",
  },

  // 7/8th Row
  leaveFromCheckboxContainer: ({ isRobot }) => ({
    gridColumnStart: 1,
    gridColumnEnd: 4,
    gridRowStart: isRobot ? 8 : 7,
  }),

  // 8/9th Row
  returnToCheckboxContainer: ({ isRobot }) => ({
    gridColumnStart: 1,
    gridColumnEnd: 4,
    gridRowStart: isRobot ? 9 : 8,
    marginTop: "-20px",
  }),
});

export const EditDriverModalContent = ({ onChange, onValidation }) => {
  const sections = useSelector(sectionsSelector);
  const vehicles = useSelector(vehiclesSelector);
  const routes = useSelector(routesSelector);
  const drivers = useSelector(driversSelector);
  const driverEdit = useSelector(driverInEditSelector);

  const isRobot = ROBOT_DRIVER_TYPE === driverEdit.driverType;
  const formStyles = useFormStyles({ isRobot });

  return (
    <WorkScheduleDayForm
      styles={formStyles}
      onChange={onChange}
      onValidation={onValidation}
      sections={sections}
      vehicles={vehicles}
      routes={routes}
      drivers={drivers}
      driverEdit={driverEdit}
      disabledControls={{
        deliveryStopTime: isRobot,
        collectionStopTime: isRobot,
        startAtSatellite: isRobot,
        endAtSatellite: isRobot,
        robotTypeCode: true,
        vehicleType: true,
      }}
      hiddenControls={{
        robotTypeCode: !isRobot,
        routeCode: true,
      }}
    />
  );
};
